'use client';



import { useNavigate } from "../../hooks/useNavigate";
import React, { useEffect } from "react";
import {
  FaCode,
  FaMobile,
  FaToolbox,
  FaPaintbrush,
  FaChartLine,
  FaServer,
  FaRobot,
  FaBagShopping,
  FaPlay,
  FaCloud,
  FaGamepad,
  FaRProject,
  FaUsers,
  FaDatabase,
  FaUpload,
  FaPencil,
  FaCartFlatbed,
  FaCriticalRole,
  FaEye,
  FaRocket,
  FaCalendar,
  FaFlagCheckered,
} from "react-icons/fa6";

import SectionType1 from "../../components/Sections/SectionType1";
import { AiOutlineMobile } from "react-icons/ai";
import { MdDesignServices, MdSecurity } from "react-icons/md";
import SecondaryTag from "../../components/Tags/SecondaryTag";

const s1 = "/assets/services/5.webp";
const s2 = "/assets/services/6.png";
const s3 = "/assets/services/10.jpg";
const s4 = "/assets/services/1.jpg";
const s5 = "/assets/services/4.jpg";
const s6 = "/assets/services/3.jpg";
const s7 = "/assets/services/2.webp";
const s8 = "/assets/services/7.jpg";
const s9 = "/assets/services/11.jpg";
const s10 = "/assets/services/9.jpg";
const s11 = "/assets/services/12.webp";
const s12 = "/assets/services/8.jpg";
function Services() {
  return (
    <div className="relative 2xl:mx-5">
      <div className="absolute inset-0 pointer-events-none z-30">
        <div className="mt-2 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="-mt-40 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        <div className="mt-2 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
        {/* <div className="-mt-40 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" /> */}
        {/* <div className="mt-2 2xl:hidden bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" /> */}
        {/* <div className="-mt-40 2xl:hidden bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" /> */}
        {/* <div className="-mt-40 2xl:hidden bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" /> */}
      </div>

      <div className="flex flex-col items-center justify-center mt-10 w-[240px] md:w-full mx-auto">
        <SecondaryTag text={"Core Services"} />
        <h1 className=" text-color-1 text-center text-4xl lg:text-6xl font-medium leading-[normal] my-10 mb-16">
          Innovate. Automate. Elevate.
        </h1>
      </div>

      <SectionType1>
        {/* <TopServices /> */}
        <InServices />
      </SectionType1>

      {/* <div className="bg-color-50 h-32 w-32 fixed right-0 bottom-0 z-50"></div> */}
    </div>
  );
}

export default Services;

const TopServices = () => {
  const services = [
    {
      id: 1,
      image: s1,
      title: "Website Design & Development",
      description:
        "Customized websites designed for high performance and seamless user engagement.",
      tags: [
        { text: "Custom Websites", icon: FaCode },
        { text: "SEO Optimization", icon: FaToolbox },
        { text: "Responsive Design", icon: FaMobile },
        { text: "Optimized APIs", icon: FaToolbox },
        { text: "Performance Optimization", icon: FaChartLine },
        // { text: "Content Management", icon: FaDatabase },
        { text: "E-commerce Integration", icon: FaBagShopping },
        // { text: "API Integration", icon: FaServer },
      ],
      // Original plans are preserved in archived-service-plans.json (not imported).
    },
    {
      id: 2,
      image: s2,
      title: "Mobile App Development",
      description:
        "User-centric mobile applications designed for both iOS and Android platforms.",
      tags: [
        { text: "Native Apps", icon: AiOutlineMobile },
        { text: "Cross-Platform Apps", icon: FaMobile },
        // { text: "Real-time Data Sync", icon: FaDatabase },
        { text: "Push Notifications", icon: FaChartLine },
        { text: "UI/UX Optimization", icon: MdDesignServices },
        { text: "Offline Access", icon: FaToolbox },
        { text: "App Store Deployment", icon: FaCode },
        { text: "User Analytics", icon: FaChartLine },
      ],
      // Original plans are preserved in archived-service-plans.json (not imported).
    },
    {
      id: 3,
      image: s3,
      title: "Custom Software Development",
      description:
        "Tailor-made software solutions to meet unique business needs with scalability and efficiency.",
      tags: [
        { text: "Business Automation", icon: FaRProject },
        { text: "Custom Features", icon: FaToolbox },
        { text: "Third-Party Integration", icon: FaCode },
        { text: "Data Security", icon: MdSecurity },
        // { text: "Workflow Optimization", icon: FaChartLine },
        { text: "AI Integration", icon: FaRobot },
        { text: "Scalable Architecture", icon: FaServer },
        { text: "Cloud Hosting", icon: FaCloud },
      ],
      // Original plans are preserved in archived-service-plans.json (not imported).
    },
    {
      id: 4,
      image: s4,
      title: "UI/UX Design",
      description:
        "Designs delivering exceptional user experiences with a focus on aesthetics and usability.",
      tags: [
        { text: "User Research", icon: FaUsers },
        { text: "Wireframing", icon: MdDesignServices },
        { text: "Prototyping", icon: FaPaintbrush },
        { text: "Interactive Design", icon: FaCode },
        { text: "Responsive Layouts", icon: FaMobile },
        { text: "A/B Testing", icon: FaChartLine },
        { text: "Design Systems", icon: FaToolbox },
        { text: "Accessibility Standards", icon: FaPaintbrush },
      ],
      // Original plans are preserved in archived-service-plans.json (not imported).
    },
  ];

  const navigate = useNavigate();

  const handleItemClick = (serviceId) => {
    // navigate(`/contact-us`, { state: { service: serviceId } });
    navigate(`/services`, { state: { service: serviceId } });
  };

  return (
    <div className="max-w-[1340px] 2xl:max-w-[1500px] mx-auto relative mb-6">
      <div className="flex flex-row flex-wrap xl:flex-col 2xl:flex-row justify-around gap-6 mx-4 md:mx-16 ">
        {services.map((service, index) => (
          <div
            key={index}
            className={`w-full md:w-[45%] lg:w-full flex flex-col lg:flex-row items-center ${
              index % 2 === 0 ? "" : "lg:flex-row-reverse"
            }`}
          >
            <div
              className="w-full xl:w-5/6 2xl:w-4/6"
              onClick={() => handleItemClick(service.id)}
            >
              <ServiceCard
                rev={index % 2 === 0}
                title={service.title}
                description={service.description}
                tags={service.tags}
                image={service.image}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const services2 = [
  {
    id: 5,
    image: s5,
    title: "Consulting Services",
    description:
      "Expert guidance for technology strategy and business optimization.",
    tags: [
      { text: "Strategy", icon: FaChartLine },
      { text: "Optimization", icon: FaUsers },
      { text: "Risk", icon: FaToolbox },
      { text: "IT Roadmap", icon: FaRProject },
    ],
  },
  {
    id: 6,
    image: s6,
    title: "Live Streaming Platform",
    description: "Broadcast live content with high-quality video streaming.",
    tags: [
      { text: "Streaming", icon: FaPlay },
      { text: "Scalable", icon: FaServer },
      { text: "Analytics", icon: FaChartLine },
      { text: "Custom Player", icon: FaCode },
    ],
  },
  {
    id: 7,
    image: s7,
    title: "E-commerce Development",
    description: "Scalable e-commerce platforms for seamless shopping.",
    tags: [
      { text: "E-commerce", icon: FaBagShopping },
      { text: "Payments", icon: MdSecurity },
      { text: "Inventory", icon: FaDatabase },
      { text: "Mobile", icon: FaMobile },
    ],
  },
  {
    id: 8,
    image: s8,
    title: "Cloud Services",
    description: "Reliable and scalable cloud solutions.",
    tags: [
      { text: "Cloud", icon: FaCloud },
      { text: "Hosting", icon: FaServer },
      { text: "Migration", icon: FaUpload },
      { text: "Data Storage", icon: FaDatabase },
    ],
  },
  {
    id: 9,
    image: s9,
    title: "Product Development",
    description: "End-to-end product development from ideation to launch.",
    tags: [
      { text: "Design", icon: FaPencil },
      { text: "Prototyping", icon: FaCartFlatbed },
      { text: "Agile", icon: FaCriticalRole },
      { text: "UX/UI", icon: FaEye },
    ],
  },
  {
    id: 10,
    image: s10,
    title: "AI & Machine Learning",
    description: "AI solutions to automate processes and deliver insights.",
    tags: [
      { text: "AI", icon: FaRobot },
      { text: "Analytics", icon: FaChartLine },
      { text: "Data Processing", icon: FaDatabase },
      { text: "Modeling", icon: FaCode },
    ],
  },
  {
    id: 11,
    image: s11,
    title: "Graphic Design & Digital Marketing",
    description: "Creative designs and marketing strategies.",
    tags: [
      { text: "Design", icon: FaPaintbrush },
      { text: "Marketing", icon: FaChartLine },
      { text: "SEO", icon: FaToolbox },
      { text: "Content", icon: FaToolbox },
    ],
  },
  {
    id: 12,
    image: s12,
    title: "Game Development",
    description: "Game design and 3D modeling for immersive experiences.",
    tags: [
      { text: "Game Design", icon: FaGamepad },
      { text: "3D Modeling", icon: FaPaintbrush },
      { text: "Physics", icon: FaRobot },
      { text: "Multiplayer", icon: FaServer },
    ],
  },
];

const services = [
  {
    id: 1,
    image: s1,
    title: "Website Design & Development",
    description: "Websites for performance and user engagement.",
    tags: [
      { text: "Custom Websites", icon: FaCode },
      { text: "Optimized", icon: FaBagShopping },
      { text: "Scalable", icon: FaMobile },
      { text: "SEO", icon: FaChartLine },
    ],
  },
  {
    id: 2,
    image: s2,
    title: "Mobile App Development",
    description: "Optimized Apps for iOS and Android.",
    tags: [
      { text: "Native Apps", icon: AiOutlineMobile },
      { text: "Cross-Platform", icon: FaMobile },
      { text: "Push Alerts", icon: FaChartLine },
      { text: "App Store", icon: FaToolbox },
    ],
  },
  {
    id: 3,
    image: s3,
    title: "Custom Software Development",
    description: "Scalable software tailored to business needs.",
    tags: [
      { text: "Automation", icon: FaRProject },
      { text: "Custom Features", icon: FaToolbox },
      { text: "Data Security", icon: MdSecurity },
      { text: "AI Integration", icon: FaRobot },
    ],
  },
  {
    id: 4,
    image: s4,
    title: "UI/UX Design",
    description: "Exceptional designs for usability and aesthetics.",
    tags: [
      { text: "User Research", icon: FaUsers },
      { text: "Prototyping", icon: FaPaintbrush },
      { text: "Interactive", icon: FaCode },
      { text: "Responsive", icon: FaMobile },
    ],
  },
  {
    id: 5,
    image: s5,
    title: "Consulting Services",
    description: "Expert advice for IT and business optimization.",
    tags: [
      { text: "Risk Analysis", icon: FaToolbox },
      { text: "Cloud Setup", icon: FaCloud },
      { text: "Automation", icon: FaRobot },
      { text: "Strategy", icon: FaChartLine },
    ],
  },
  {
    id: 6,
    image: s6,
    title: "Live Streaming Platform",
    description: "High-quality solutions for real-time video streaming.",
    tags: [
      { text: "HD Streaming", icon: FaPlay },
      { text: "Live Chat", icon: FaServer },
      { text: "Scheduling", icon: FaCalendar },
      { text: "Analytics", icon: FaChartLine },
    ],
  },
  {
    id: 7,
    image: s7,
    title: "E-commerce Development",
    description: "Secure, scalable platforms for seamless shopping.",
    tags: [
      { text: "Storefronts", icon: FaBagShopping },
      { text: "Easy Payments", icon: MdSecurity },
      { text: "Inventory", icon: FaDatabase },
      { text: "Mobile Ready", icon: FaMobile },
    ],
  },
  {
    id: 8,
    image: s8,
    title: "Cloud Services",
    description: "Reliable solutions for secure data access and storage.",
    tags: [
      { text: "Quick Hosting", icon: FaCloud },
      { text: "Monitoring", icon: FaChartLine },
      { text: "Migration", icon: FaUpload },
      { text: "Security", icon: MdSecurity },
    ],
  },
  {
    id: 9,
    image: s9,
    title: "Product Development",
    description: "Complete solutions from design to market launch.",
    tags: [
      { text: "Scalable Design", icon: FaPencil },
      { text: "Testing", icon: FaFlagCheckered },
      { text: "Agile Method", icon: FaCriticalRole },
      { text: "Launch", icon: FaRocket },
    ],
  },
  {
    id: 10,
    image: s10,
    title: "AI & Machine Learning",
    description: "Intelligent solutions for automation and insights.",
    tags: [
      { text: "Personalized", icon: FaChartLine },
      { text: "Automation", icon: FaRobot },
      { text: "AI Models", icon: FaCode },
      { text: "Big Data", icon: FaServer },
    ],
  },
  {
    id: 11,
    image: s11,
    title: "Graphic Design & Marketing",
    description: "Creative designs to boost brand visibility.",
    tags: [
      { text: "Branding", icon: FaPaintbrush },
      { text: "Social Media", icon: FaChartLine },
      { text: "Quality Content", icon: FaToolbox },
      { text: "Advertising", icon: FaBagShopping },
    ],
  },
  {
    id: 12,
    image: s12,
    title: "Game Development",
    description: "Cutting-edge games with immersive experiences.",
    tags: [
      { text: "3D Models", icon: FaGamepad },
      { text: "Multiplayer", icon: FaServer },
      { text: "Cross-Platform", icon: AiOutlineMobile },
      { text: "VR/AR", icon: FaCode },
    ],
  },
];

const InServices = () => {
  const navigate = useNavigate();

  const handleItemClick = (serviceId) => {
    navigate(`/contact-us`, { state: { service: serviceId } });
  };

  return (
    <div className=" max-w-[1340px] 2xl:max-w-[1700px] mx-auto relative">
      <div className="flex flex-row flex-wrap xl:flex-col 2xl:flex-row justify-around gap-8 mx-4 md:mx-16 ">
        {services.map((service, index) => (
          <div
            key={index}
            className={`w-full md:w-[45%] lg:w-full 2xl:w-[48%] flex flex-col lg:flex-row items-center ${
              index % 2 === 0 ? "" : "lg:flex-row-reverse"
            }`}
          >
            <div
              className="w-full xl:w-5/6 2xl:w-full"
              onClick={() => handleItemClick(service.id)}
            >
              <ServiceCard
                rev={
                  !(window.innerWidth >= 1536
                    ? index % 4 === 2 || index % 4 === 3
                    : index % 2 === 0)
                }
                title={service.title}
                description={service.description}
                tags={service.tags}
                image={service.image}
              />
            </div>
            {/* <div
              className={`flex ${
                !(index % 4 === 2 || index % 4 === 3)
                  ? "justify-start"
                  : "justify-end"
              }`}
            >
              <div
                className="w-full xl:w-5/6"
                onClick={() => handleItemClick(service.id)}
              >
                <ServiceCard
                  rev={
                    !(window.innerWidth >= 1536
                      ? index % 4 === 2 || index % 4 === 3
                      : index % 2 === 0)
                  }
                  title={service.title}
                  description={service.description}
                  tags={service.tags}
                  image={service.image}
                  compact
                />
              </div>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

const Tag = ({ text, Icon }) => (
  <div className="flex items-center gap-2.5 py-2 px-2 md:px-4 rounded-lg border-[0.771px] border-color-97 bg-color-99 group transition-all duration-300">
    <Icon className="w-4 h-4 text-[#cfd3da] group-hover:text-[var(--accent-light)] transition-all duration-300" />
    <div className="text-[#cfd3da] text-xs leading-[normal] transition-all duration-300 whitespace-nowrap">
      {text}
    </div>
  </div>
);

const ServiceCard = ({ rev, title, description, tags, image, compact }) => {
  const [isLargeScreen, setIsLargeScreen] = React.useState(
    window.innerWidth >= 1024
  );

  React.useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="relative h-full p-px rounded-xl w-full overflow-hidden cursor-pointer group">
      <div
        className={`absolute inset-0 rounded-xl bg-[linear-gradient(155deg,var(--accent-light),var(--secondary-bg)_80%)] transition-transform duration-700 group-hover:rotate-180 blur-3xl scale-150`}
      ></div>
      <div
        className={`lg:h-52 ${
          compact ? "2xl:h-[250px]" : "2xl:h-[230px]"
        } flex flex-col lg:flex-row overflow-hidden ${
          !rev ? "lg:flex-row-reverse" : ""
        } items-center lg:items-stretch gap-0 lg:gap-6 rounded-xl bg-[var(--secondary-bg)] backdrop-blur-[7px] shadow-lg`}
      >
        {/* Image Section */}
        <div
          className="w-full lg:w-[40%] h-40 lg:h-full scale-125 md:scale-150 lg:scale-125 group-hover:scale-110 transition-all duration-700"
          style={
            isLargeScreen
              ? {
                  clipPath: !rev
                    ? "polygon(0 0, 100% 0, 100% 100%, 20% 100%)"
                    : "polygon(0 0, 80% 0, 100% 100%, 0% 100%)",
                }
              : {
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0% 70%)",
                }
          }
        >
          <img
            loading="lazy"
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-125 transition-all duration-700 md:grayscale-[70%] group-hover:grayscale-[0%]"
          />
        </div>

        {/* Content Section */}
        <div className="w-full lg:w-[60%] relative flex flex-col justify-center p-3 md:p-6 ">
          <div className="z-10 flex flex-col items-start gap-3">
            <div className="text-color-1 text-xl font-semibold md:font-bold">
              {title}
            </div>
            <div className="text-color-2">{description}</div>
          </div>
          <div className="flex flex-col lg:items-end gap-4 mt-4">
            <div className="grid grid-cols-2 sm:grid-cols-1 lg:grid-cols-2 gap-2 gap-y-3 md:gap-4 px-2 lg:px-4 2xl:px-0">
              {tags.map((tag, index) => (
                <div className="flex justify-center" key={index}>
                  <Tag text={tag.text} Icon={tag.icon} />
                </div>
              ))}
            </div>
          </div>
        </div>
        <div
          className={`absolute top-5 ${
            rev ? "right-5" : "left-5"
          } -rotate-45 w-[300px] h-[100px] bg-[radial-gradient(circle,_var(--accent-dark),_var(--accent-dark))] blur-3xl opacity-20 group-hover:opacity-35 transition-all duration-700`}
        ></div>
      </div>
    </div>
  );
};
